'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const navLinks = [
  { label: 'Услуги', href: '#services' },
  { label: 'Калькулятор', href: '#calculator' },
  { label: 'О нас', href: '#why' },
  { label: 'Контакты', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="nav-load loaded fixed top-0 left-0 w-full z-50 px-4 py-3">
      <div
        className={`max-w-7xl mx-auto flex items-center justify-between rounded-2xl px-5 py-3 transition-all duration-500 ${
          scrolled
            ? 'bg-white/95 shadow-xl border border-border backdrop-blur-md'
            : 'bg-white/10 backdrop-blur-md border border-white/20'
        }`}
      >
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span
            className={`font-bold text-lg tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-foreground' : 'text-white'
            }`}
          >
            СлавСтрой
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-medium transition-colors duration-200 hover:text-primary ${
                scrolled ? 'text-muted-foreground' : 'text-white/80'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={() => handleNavClick('#contact')}
            className="flex items-center gap-2 bg-primary text-primary-foreground px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl text-sm font-semibold hover:bg-accent transition-all duration-200 shadow-md btn-pulse"
          >
            <span className="hidden xs:inline">Оставить заявку</span>
            <span className="xs:hidden">Заявка</span>
          </button>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              scrolled ? 'text-foreground' : 'text-white'
            }`}
            aria-label="Меню"
          >
            <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden mt-2 mx-auto max-w-7xl bg-white border border-border rounded-2xl p-6 shadow-2xl">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className="text-left text-base font-medium text-foreground hover:text-primary transition-colors py-1"
              >
                {link.label}
              </button>
            ))}
            <hr className="border-border" />
            <button
              onClick={() => handleNavClick('#contact')}
              className="w-full py-3 text-center font-semibold text-primary-foreground bg-primary rounded-xl hover:bg-accent transition-all"
            >
              Оставить заявку
            </button>
          </div>
        </div>
      )}
    </header>
  );
}